import { RestApi } from '@maverick/http';

export const SitecoreClient = new RestApi('/api/sitecore');
